// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.109.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.109.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ``, "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"black": `#000`,
	"white": `#fff`,
	"primary_20": `#1a1a1a`,
	"primary_30": `#2d2d2d`,
	"primary_35": `#3a3a3a`,
	"primary_40": `#525252`,
	"primary_45": `#636363`,
	"primary_50": `#8e8e8e`,
	"primary_60": `#a3a3a3`,
	"primary_70": `#c4c4c4`,
	"primary_80": `#e5e5e5`,
	"primary_90": `#f5f5f5`,
	"secondary_40": `#3b71f7`,
	"secondary_80": `#efeaf6`,
	"gradient_20": `linear-gradient(90deg, #f9e0a2 0%, #efb217 100%)`,
	"gradient_40": `linear-gradient(90deg, #00b39b, #3b71f7)`,
	"gradient_60": `linear-gradient(90deg, #d9f3f0, #e1eafe)`,
	"gradient_80": `linear-gradient(180deg, #ffffff 0%, #f2f4ff 100%)`,
	"error_20": `#410001`,
	"error_30": `#7d0008`,
	"error_40": `#bf3c32`,
	"error_45": `#e24d39`,
	"error_50": `#ff8a7c`,
	"error_60": `#df847d`,
	"error_80": `#ffdad5`,
	"neutral_10": `#26282d`,
	"neutral_20": `#46474a`,
	"neutral_30": `#76777a`,
	"neutral_40": `#aeafb1`,
	"neutral_60": `#dbdcdf`,
	"neutral_80": `#eef0f5`,
	"neutral_90": `#fafafa`,
	"warning_40": `#f9e0a2`,
	"warning_50": `#f5d174`,
	"warning_60": `#efb217`,
	"warning_80": `#ffefc8`,
	"warning_90": `#fff8e5`,
	"red_80": `#fcedeb`,
	"green_30": `#006b5d`,
	"green_50": `#00b39b`,
	"green_70": `#80d9cd`,
	"green_80": `#d7f4f3`,
	"green_90": `#ccf0eb`,
	"accent_40": `#00b39b`,
	"highlight_40": `#a5b8f4`,
	"highlight_50": `#f5d174`,
	"yellow_20": `#d08d00`,
	"yellow_30": `#e19900`,
	"yellow_40": `#efb217`,
	"yellow_50": `#f5d174`,
	"yellow_60": `#f9e0a2`
};
export default ___CSS_LOADER_EXPORT___;
